
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/announcement/nvidia-inception-program",
      function () {
        return require("private-next-pages/announcement/nvidia-inception-program/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/announcement/nvidia-inception-program"])
      });
    }
  